var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-tooltip",
    {
      attrs: { bottom: "", disabled: _vm.disabled },
      scopedSlots: _vm._u(
        [
          {
            key: "activator",
            fn: function (ref) {
              var on = ref.on
              return [
                _c(
                  "v-btn",
                  _vm._g(
                    {
                      attrs: {
                        icon: "",
                        "aria-label": _vm.ariaLabel,
                        outlined: _vm.outlined,
                        disabled: _vm.disabled,
                      },
                      on: { click: _vm.clickHandler },
                    },
                    on
                  ),
                  [_c("v-icon", [_vm._v(_vm._s(_vm.icon))])],
                  1
                ),
              ]
            },
          },
        ],
        null,
        true
      ),
    },
    [_vm._v(" "), _c("span", [_vm._v(_vm._s(_vm.tooltip))])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }